import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UWRequirementActionEvent, UWRequirementTableData } from '@Underwriting/models';
import { UWRequirementTableActions } from '../uw-requirements-expand-table';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'uw-requirements-actions-item-agent-communications',
    templateUrl: './uw-requirements-actions-item-agent-communications.component.html',
    styleUrls: ['./uw-requirements-actions-item-agent-communications.component.scss'],
    imports: [SharedModule],
})
export class UWRequirementsActionsItemAgentCommunicationsComponent {
    @Input() caseRequirement: UWRequirementTableData;
    @Output() onMenuAction = new EventEmitter<UWRequirementActionEvent>();

    public get UWRequirementTableActions() {
        return UWRequirementTableActions;
    }

    handleMenuAction() {

        const actionEvent: UWRequirementActionEvent = {
            action: UWRequirementTableActions.AddAgentCommunications,
            data: this.caseRequirement
        };
        this.onMenuAction.emit(actionEvent);
    }
}